export default __webpack_public_path__ + "static/media/iPhone_1.71daa630.png";